// Get Performance Exports
export const GET_PERFORMANCE_EXPORTS_REQUEST = 'GET_PERFORMANCE_EXPORTS_REQUEST';
export const GET_PERFORMANCE_EXPORTS_DONE = 'GET_PERFORMANCE_EXPORTS_DONE';
export const GET_PERFORMANCE_EXPORTS_FAILED = 'GET_PERFORMANCE_EXPORTS_FAILED';

// Operations
export const UPDATE_USER_PERFORMANCE_EXPORTS = 'UPDATE_USER_PERFORMANCE_EXPORTS';
export const TOGGLE_PERFORMANCE_EXPORTS = 'TOGGLE_PERFORMANCE_EXPORTS';
export const TOGGLE_ALL_PERFORMANCE_EXPORTS = 'TOGGLE_ALL_PERFORMANCE_EXPORTS';
export const SET_PERFORMANCE_EXPORTS_FILTER = 'SET_PERFORMANCE_EXPORTS_FILTER';
export const SET_PERFORMANCE_EXPORTS_ALL_FILTERS = 'SET_PERFORMANCE_EXPORTS_ALL_FILTERS';
export const CLEAR_PERFORMANCE_EXPORTS_FILTERS = 'CLEAR_PERFORMANCE_EXPORTS_FILTERS';
export const PERFORMANCE_EXPORTS_SET_PAGE = 'PERFORMANCE_EXPORTS_SET_PAGE';